<script lang="ts" setup>
import InfoCard from '@/home/components/InfoCard.vue';
</script>

<template>
  <section class="page-about-organization-structure pt-48px">
    <div class="about-organization-structure-container container">
      <h2 class="m-0 text-center text-32px font-medium">{{ $t('about.organizationStructure.title') }}</h2>

      <div class="logo mt-32px">
        <img src="@/home/assets/common/logo-with-title.svg" alt="LOGO" class="mx-auto block w-400px">
      </div>

      <InfoCard class="before-brand-primary relative mx-auto mt-48px w-720px before:absolute before:left-50% before:top--37px before:ml--1px before:h-38px before:w-px before:content-empty" :title="$t('about.organizationStructure.structure1.title')" small>
        <p class="m-0 text-16px leading-24px">{{ $t('about.organizationStructure.structure1.content') }}</p>
      </InfoCard>

      <ul class="mx-0 mb-0 mt-48px flex list-none justify-between p-0">
        <li>
          <InfoCard class="h-164px w-442px <2xl:w-352px" :title="$t('about.organizationStructure.structure3.title')" small>
            <p class="m-0 h-full overflow-y-auto text-16px leading-24px">{{ $t('about.organizationStructure.structure3.content') }}</p>
          </InfoCard>
        </li>
        <li>
          <InfoCard class="relative h-164px w-442px before:absolute before:left-50% before:top--48px before:ml--1px before:h-49px before:w-px before:bg-brand-primary before:content-empty <2xl:w-464px" :title="$t('about.organizationStructure.structure4.title')" small>
            <p class="m-0 h-full overflow-y-auto text-16px leading-24px">{{ $t('about.organizationStructure.structure4.content') }}</p>
          </InfoCard>
        </li>
        <li>
          <InfoCard class="h-164px w-442px <2xl:w-352px" :title="$t('about.organizationStructure.structure2.title')" small>
            <p class="m-0 h-full overflow-y-auto text-16px leading-24px">{{ $t('about.organizationStructure.structure2.content') }}</p>
          </InfoCard>
        </li>
      </ul>

      <ul class="structure-tree relative mx-auto mb-0 mt-48px box-border w-1200px flex list-none justify-between p-0 before:absolute before:right-50% before:top--49px before:h-48px before:w-px before:bg-brand-primary before:content-empty <2xl:w-1090px">
        <li class="h-24px w-px"></li>
        <li class="h-24px w-px"></li>
        <li class="h-24px w-px"></li>
        <li class="h-24px w-px"></li>
        <li class="h-24px w-px"></li>
        <li class="h-24px w-px"></li>
        <li class="h-24px w-px"></li>
        <li class="h-24px w-px"></li>
        <li class="h-24px w-px"></li>
      </ul>

      <ul class="structure-tree-text mx-15px mb-0 mt-10px box-border flex list-none justify-between p-0 text-brand-primary <2xl:mx--5px">
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department1') }}</li>
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department2') }}</li>
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department3') }}</li>
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department4') }}</li>
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department5') }}</li>
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department6') }}</li>
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department7') }}</li>
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department8') }}</li>
        <li class="text-center text-balance text-16px">{{ $t('about.organizationStructure.department9') }}</li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.page-about-organization-structure {
  .about-organization-structure-container {
    .before-brand-primary {
      &::before {
        background: linear-gradient(to top, rgba(17, 128, 255, 1) 0%, rgba(17, 128, 255, 0) 100%);
      }
    }

    .structure-tree {
      border-top: 1px solid #1180ff;

      li {
        background: linear-gradient(to bottom, rgba(17, 128, 255, 1) 0%, rgba(17, 128, 255, 0) 100%);
      }
    }

    .structure-tree-text {
      li {
        box-sizing: border-box;
        width: calc(100% / 10);
        padding-right: 10px;
        padding-left: 10px;
      }
    }
  }
}
</style>
